import { combineReducers } from "redux";
import { adminReducer as adminPage } from "./../api/admin/adminReducer";
import { faqReducer as faqPage } from "../api/faq/faqReducer";
import { pageReducer as pagePage } from "../api/page/pageReducer";
import { orderReducer as orderPage } from "../api/order/orderReducer";
import { roleReducer as rolePage } from "../api/role/roleReducer";
import { affiliateReducer as affiliatePage } from "../api/affiliate/affiliateReducer";
import { userReducer as userPage } from "../api/user/userReducer";
import { contactUsReducer as contactUsPage } from "../api/contact-us/contact-usReducer";
import { categoryReducer as categoryPage } from "../api/category/categoryReducer";
import { productReducer as productPage } from "../api/product/productReducer";
import { orderReducer } from "../api/order/orderReducer";
import { withdrawalReducer as withdrawalPage } from "../api/withdrawal/withdrawalReducer";
import { expenseReducer as expensePage } from "../api/expense/expenseReducer";

 const appReducer = combineReducers({
  adminPage,
  faqPage,
  pagePage,
  rolePage,
  contactUsPage,
  affiliatePage,
  userPage,
  orderPage,
  categoryPage,
  productPage,   
  orderReducer,
  withdrawalPage,
  expensePage
});

export default appReducer;
